export default `:host {
  display: inline-flex;
  height: var(--ids-segmented-control-height);
  box-sizing: border-box;
}

:host([hidden]) {
  display: none;
}

:host([compact]) {
  height: var(--ids-segmented-control-compact-height);
}

.ids-segmented-control {
  align-items: center;
  background-color: var(--ids-color-accent-neutral-weakest);
  border-radius: var(--ids-border-radius-sm);
  display: inline-flex;
  gap: var(--ids-space-2xs);
  padding: var(--ids-space-2xs);
}

:host([compact]) .ids-segmented-control {
  gap: var(--space-3xs);
  padding: var(--space-3xs);
}

::slotted(*) {
  --ids-button-icon-height: var(--ids-segmented-control-button-height);
  height: var(--ids-segmented-control-button-height);
  box-sizing: border-box;
}

:host([compact]) ::slotted(*) {
  --ids-button-icon-height: var(--ids-segmented-control-compact-button-height);
  --ids-button-compact-height: var(--ids-segmented-control-compact-button-height);
  --ids-button-icon-button-compact-height: var(--ids-segmented-control-compact-button-height);
  height: var(--ids-segmented-control-compact-button-height);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtc2VnbWVudGVkLWNvbnRyb2wiLCJzb3VyY2VzIjpbImlkcy1zZWdtZW50ZWQtY29udHJvbC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBRUE7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFFQSIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gIGhlaWdodDogdmFyKC0taWRzLXNlZ21lbnRlZC1jb250cm9sLWhlaWdodCk7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG59XG5cbjpob3N0KFtoaWRkZW5dKSB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbjpob3N0KFtjb21wYWN0XSkge1xuICBoZWlnaHQ6IHZhcigtLWlkcy1zZWdtZW50ZWQtY29udHJvbC1jb21wYWN0LWhlaWdodCk7XG59XG5cbi5pZHMtc2VnbWVudGVkLWNvbnRyb2wge1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1pZHMtY29sb3ItYWNjZW50LW5ldXRyYWwtd2Vha2VzdCk7XG4gIGJvcmRlci1yYWRpdXM6IHZhcigtLWlkcy1ib3JkZXItcmFkaXVzLXNtKTtcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gIGdhcDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gIHBhZGRpbmc6IHZhcigtLWlkcy1zcGFjZS0yeHMpO1xufVxuXG46aG9zdChbY29tcGFjdF0pIC5pZHMtc2VnbWVudGVkLWNvbnRyb2wge1xuICBnYXA6IHZhcigtLXNwYWNlLTN4cyk7XG4gIHBhZGRpbmc6IHZhcigtLXNwYWNlLTN4cyk7XG59XG5cbjo6c2xvdHRlZCgqKSB7XG4gIC0taWRzLWJ1dHRvbi1pY29uLWhlaWdodDogdmFyKC0taWRzLXNlZ21lbnRlZC1jb250cm9sLWJ1dHRvbi1oZWlnaHQpO1xuXG4gIGhlaWdodDogdmFyKC0taWRzLXNlZ21lbnRlZC1jb250cm9sLWJ1dHRvbi1oZWlnaHQpO1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xufVxuXG46aG9zdChbY29tcGFjdF0pIDo6c2xvdHRlZCgqKSB7XG4gIC0taWRzLWJ1dHRvbi1pY29uLWhlaWdodDogdmFyKC0taWRzLXNlZ21lbnRlZC1jb250cm9sLWNvbXBhY3QtYnV0dG9uLWhlaWdodCk7XG4gIC0taWRzLWJ1dHRvbi1jb21wYWN0LWhlaWdodDogdmFyKC0taWRzLXNlZ21lbnRlZC1jb250cm9sLWNvbXBhY3QtYnV0dG9uLWhlaWdodCk7XG4gIC0taWRzLWJ1dHRvbi1pY29uLWJ1dHRvbi1jb21wYWN0LWhlaWdodDogdmFyKC0taWRzLXNlZ21lbnRlZC1jb250cm9sLWNvbXBhY3QtYnV0dG9uLWhlaWdodCk7XG5cbiAgaGVpZ2h0OiB2YXIoLS1pZHMtc2VnbWVudGVkLWNvbnRyb2wtY29tcGFjdC1idXR0b24taGVpZ2h0KTtcbn1cbiJdfQ== */`;
